/**
 *
 * Lapsed Subscription Modal
 *
 */

import React, { Component } from "react";
import { Wrapper, Text } from "./styledComponents";
import Modal from "components/Modal";
import { ButtonLink } from "components/Button/ButtonLink";

class LapsedModal extends Component {
  render() {
    return (
      <Modal
        dismissable={false}
        title="Inactive Account"
        tinyModal={true}
      >
        <Wrapper style={{padding: '0'}}>
          <Text>
            Please select a Movebooth software plan to reactivate your account.
          </Text>
          <p style={{ marginTop: "2em", textAlign: "center" }}>
            <ButtonLink
              href="https://www.movebooth.com/subscribe"
              rel="noreferrer noopener"
              target="_blank"
              type="button"
            >
              Browse Movebooth Plans
            </ButtonLink>
          </p>
        </Wrapper>
      </Modal>
    );
  }
}

export default LapsedModal;



// WEBPACK FOOTER //
// ./src/components/LapsedModal/index.js